export enum RoutesKey {
  HOME = 'home',
  AUTH_SIGN_IN = 'sign-in',
  AUTH_SIGN_UP = 'become-member',
  AUTH_FORGOT_PASSWORD = 'forgot-password',
  AUTH_FORGOT_PASSWORD_OK = 'forgot-password-ok',
  AUTH_RESET_PASSWORD = 'reset-password',
  AUTH_RESET_PASSWORD_OK = 'reset-password-ok',
  EDITOR_NEW_MESSAGE = 'editor-new-message',
  AUTH_EMAIL_VERIFIER = 'verify-email',
  AUTH_EMAIL_VERIFIER_ASK = 'email-verifier-ask',
  GEOPORTAIL = 'geoportail',
  /** Public project detail: path `/projects/:id` */
  PROJECT_PAGE = 'projectPage',
  INFRASTRUCTURE_FICHE = 'infrastructure-fiche',
  ADMIN = 'admin',
  USERACCOUNT = 'userAccount',
  ADMINUSER = 'adminUsers',
  ADMIN_HABILITATIONS = 'adminHabilitations',
  ADMIN_SYNCHRONISATION = 'adminSynchronisation',
  ADMINCONTENT = 'adminContent',
  ADMINPROJECTS = 'adminProjects',
  ADMINRESOURCES = 'adminResources',
  ADMIN_INDICATOR_CREATION = 'adminIndicatorCreation',
  ADMIN_PARAMETRAGE = 'adminParametrage',
  ADMIN_INDICATOR_LIST = 'adminIndicatorList',
  ADMIN_INDICATOR_EDIT = 'adminIndicatorEdit',
  ADMIN_INDICATOR_COMMUNAL_EDIT = 'adminIndicatorCommunalEdit',
  ADMIN_INDICATOR_ADVANCED_CREATION = 'adminIndicatorAdvancedCreation',
  ADMIN_THEMATIQUES_DOMAINES = 'adminThematiquesDomaines',
  ADMIN_THEMATIQUES_SOUSDOMAINES = 'adminThematiquesSousDomaines',
  ADMIN_THEMATIQUES_COMPETENCES = 'adminThematiquesCompetences',
  ADMIN_INDICATOR_RECALCULATE = 'adminIndicatorRecalculate',
  ADMIN_INFRASTRUCTURE_TYPES = 'adminInfrastructureTypes',
  ADMIN_INFRASTRUCTURE_ATTRIBUTES = 'adminInfrastructureAttributes',
  ADMIN_INFRASTRUCTURE_FICHE_DATA = 'adminInfrastructureFicheData',
  ADMIN_ATTRIBUT_CHOIX = 'adminAttributChoix',
  ADMIN_ATOUTS_LIST = 'adminAtoutsList',
  ADMIN_MAP_STYLES_LIST = 'adminMapStylesList',
  ADMIN_MAP_STYLE_EDIT = 'adminMapStyleEdit',
  ADMIN_OSM_MAP_STYLES_LIST = 'adminOsmMapStylesList',
  ADMIN_ICONS = 'adminIcons',
  NATURAL_LANGUAGE_QUERY = 'naturalLanguageQuery',
  DASHBOARD_MAIRE = 'dashboardMaire',
  DASHBOARD_CENTRAL = 'dashboardCentral',
}
